import { apiDate, optionalString, uuid, zenum, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { optionalApiDate } from '../schemaLib';

export const ApiUserMessageChannel = zenum('sms', 'whatsapp', 'cli', 'quiet');
export const ApiUserSchema = zodLess({
  id: uuid,
  createdAt: apiDate,
  updatedAt: apiDate,
  deletedAt: optionalApiDate,
  name: optionalString,
  email: optionalString,
  phoneNumber: optionalString,
  conversationStateId: optionalString,
  messageChannel: ApiUserMessageChannel.optional(),
}, { ref: 'user' });
export type ApiUser = ZodLessInfer<typeof ApiUserSchema>;
export const getUserQueryKeyPrefix = () => `user`;
export const getUsersQueryKey = (search?: string) => `users/${search?.trim() || 'all'}`;
export const getUserByIdQueryKey = (userId: string | undefined | null) => `${getUserQueryKeyPrefix()}/${userId}`;
export const getUsersByOrgMarketIdQueryKey = (orgMarketId?: string) => `users/byOrgMarketId/${orgMarketId}`;
export const getUsersForScanQueryKey = (scanId?: string) => `usersForScan/${scanId}`;

export const ApiUpdateUserSchema = zodLess({
  name: optionalString,
  email: optionalString,
  phoneNumber: optionalString,
  messageChannel: ApiUserMessageChannel.optional(),
}, { ref: 'updateUser' });
export type ApiUpdateUser = ZodLessInfer<typeof ApiUpdateUserSchema>;
